import "./Footer.scss";

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <div className="container">
        &copy; 2024 Xinhao Liang. All Rights Reserved.
      </div>
    </div>
  )
}

export default Footer;
